import axios, { AxiosRequestConfig } from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'
import queryString from 'query-string'

import parse from './parse'
import type { FetchSeminarsParams, RawSeminar } from './types'

const CMS_API_BASE = process.env.CMS_API_BASE

export async function fetchSeminarsNearMe(
  params: FetchSeminarsParams,
  token?: string,
) {
  const headers = {} as AxiosRequestConfig['headers']

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await axios
    .get(
      `${CMS_API_BASE}/seminars/me?${queryString.stringify(
        decamelizeKeys(params),
      )}`,
      {
        headers,
      },
    )
    .then(
      (response) =>
        (camelizeKeys(
          response.data.near_me.hits.hit,
        ) as unknown) as RawSeminar[],
    )

  return response.map(parse)
}

export async function fetchSeminars(params: FetchSeminarsParams) {
  const response = await axios
    .get(
      `${CMS_API_BASE}/seminars?${queryString.stringify(
        decamelizeKeys(params),
      )}`,
    )
    .then(
      (response) =>
        (camelizeKeys(response.data.hits.hit) as unknown) as RawSeminar[],
    )

  return response.map(parse)
}

export { default as fetchFindACourse } from './fetchFindACourse'
export { default as fetchSeminarPrice } from './fetchSeminarPrice'
